import React from 'react';
import { SparklesIcon } from './Icons';

const TestimonialsSection = () => {

  const testimonials = [
    {
      name: 'Akash S.',
      role: 'CEO & Founder',
      company: 'Skooliq',
      quote: 'Cortex Orchestrator transformed how we deliver educational and operational workflows. Having specialized Planner, Tool, and Critic agents run in parallel with guaranteed zero hallucinations saved our engineering and operations teams hundreds of hours each week.',
      rating: 5,
      website: 'https://www.skooliq.in/',
      metric: '82% faster SLA'
    },
    {
      name: 'Priya M.',
      role: 'VP of Engineering',
      company: 'OmniCloud FinTech',
      quote: 'The multi-tenant architecture and strict ThreadLocal context segregation gave our compliance team 100% confidence. Being able to onboard custom Postman collections in minutes and execute verified Stripe refunds autonomously is unmatched.',
      rating: 5,
      website: '#',
      metric: 'Zero compliance leaks'
    }
  ];

  const Stars = ({ rating }) => {
    return (
      <div className="flex space-x-1">
        {[...Array(rating)].map((_, i) => (
          <svg key={i} className="w-4 h-4 text-amber-400 fill-amber-400" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    );
  };

  return (
    <section id="testimonials" className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16 space-y-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-brand-500/10 text-brand-600 dark:text-brand-400 border border-brand-500/20 font-inter">
            <SparklesIcon className="w-3.5 h-3.5" />
            <span>Proven Enterprise Impact</span>
          </div>
          <h2 className="text-3xl sm:text-5xl font-extrabold font-outfit text-slate-900 dark:text-white tracking-tight">
            Trusted by Modern Operational Teams
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-base sm:text-lg font-light leading-relaxed">
            See how forward-thinking leaders automate multi-step transactions, support tickets, and knowledge systems.
          </p>
        </div>

        {/* Testimonial Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="glass-panel p-7 sm:p-8 rounded-3xl flex flex-col justify-between text-left specular-border hover:border-brand-500/40 transition-all duration-300 shadow-lg"
            >
              <div>
                <div className="flex items-center justify-between mb-4">
                  <Stars rating={t.rating} />
                  <span className="text-[10px] font-bold font-mono px-2.5 py-0.5 rounded-full bg-brand-500/10 text-brand-600 dark:text-brand-300 border border-brand-500/20">
                    {t.metric}
                  </span>
                </div>
                <p className="text-slate-700 dark:text-slate-200 text-sm leading-relaxed font-light mb-6">
                  "{t.quote}"
                </p>
              </div>

              <div className="pt-4 border-t border-slate-200/80 dark:border-slate-800 flex items-center justify-between">
                <div>
                  <h4 className="text-sm font-bold text-slate-900 dark:text-white font-outfit">
                    {t.name}
                  </h4>
                  <p className="text-xs text-slate-500 dark:text-slate-400">
                    {t.role}, <strong className="font-semibold text-slate-700 dark:text-slate-300">{t.company}</strong>
                  </p>
                </div>
                {t.website !== '#' && (
                  <a
                    href={t.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs font-semibold text-brand-600 dark:text-brand-400 hover:underline flex items-center gap-1"
                  >
                    <span>Visit</span>
                    <span>&rarr;</span>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
